export class FiltroPadraoPec{
  codigoPolo?:number;
  codigoDiretoria:number;
  codigoMunicipio?:number;
  codigoEscola?:number;
  codigoTurno?:number;
  anoAtual?:number;
  codigoTipoEnsino?:number;
  nomeTipoEnsino?:string;
  atividadeDiretoria?:boolean = false;
  psicologosInativos?:boolean = false;
  fpDataInicio?:Date | null;
  fpDataFim?:Date | null;
  cpf?: string;
}
